var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenericCardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 50,
    viewBox: "0 0 64 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 50,
    rx: 8,
    fill: "#EEF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 8H11C9.33929 8 8.01071 9.32812 8 10.975V39.025C8.02143 40.6719 9.33929 42 11 42H53C54.6714 42 56 40.6506 56 38.9931V11.0069C56 9.34938 54.6714 8 53 8ZM12.8321 11.4H51.1571C51.8964 11.4 52.4536 11.9419 52.5607 12.675V14.8H11.4286V12.6431C11.5357 11.9206 12.1036 11.4 12.8321 11.4ZM51.1679 38.6H12.8321C12.0929 38.6 11.5357 38.0794 11.4286 37.3569V25H52.5714V37.325C52.4643 38.0581 51.8964 38.6 51.1679 38.6Z",
    fill: "#4F46E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8574 30.0996H35.4288V31.7996H14.8574V30.0996ZM14.8574 33.4996H25.1431V35.1996H14.8574V33.4996ZM42.286 30.0996H49.1431V35.1996H42.286V30.0996Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericCardLogo);
export default __webpack_public_path__ + "static/media/generic-card-logo.8fb6b1350f06bccdd5a0d2a907006f76.svg";
export { ForwardRef as ReactComponent };